import { GroupTableType } from "helpers/models";

export default (grouped: GroupTableType): number => {
  // 1. Calculate the sum for each key
  const summary = Object.fromEntries(
    Object.entries(grouped).map(([key, list]) => [
      key,
      list.reduce((sum, item) => sum + item.count, 0)
    ])
  );

  // 2. Get the maximum value from the sums
  const maxCount = Math.max(...Object.values(summary));

  return maxCount;
};
